import { SnapshotOut, types } from 'mobx-state-tree';
import { ApiLiveEventsStatusItemData, ApiLiveEventsStatusResultItemData, ResultFlag } from '../../dtos/apiLiveEventsDtos';
import { observable } from 'mobx';
import { IEventResult } from '../../api/proto/apiContract';
import { tailorResultScoreValues } from '../liveEvent';

export interface ITicketSelectionEventStatusAsStore {
    mainScore: string;
    stateName: string;
    stateTime: number | null;
    importantResults: ITicketSelectionEventStatusResultAsStore[];
}

export interface ITicketSelectionEventStatusResultAsStore {
    id: number,
    score: string,
    score1: string,
    score2: string,
    isGame: boolean,
    isHalf: boolean
}

export const TicketSelectionEventStatusResultStore = types
    .model("ticketSelectionEventStatusResultStore", {
        id: types.number,
        score: types.string,
        score1: types.string,
        score2: types.string,
        isGame: types.boolean,
        isHalf: types.boolean
    }).actions(self => {

        const tailorScoreValues = (flags: ResultFlag): void => {
            tailorResultScoreValues(self, flags);
        }

        return {
            tailorScoreValues
        }
    });

export const TicketSelectionEventStatusStore = types
    .model("ticketSelectionEventStatusStore", {
        mainScore: types.string,
        stateName: types.string,
        stateTime: types.maybeNull(types.number),
        importantResults: types.array(TicketSelectionEventStatusResultStore)
    })
    .actions(self => {

        const setDataFromLiveApi = (source: ApiLiveEventsStatusItemData) => {
            self.mainScore = source.MainScore,
                self.stateName = source.StateName,
                self.stateTime = source.StateTime,
                self.importantResults = observable(source.ImportantResults.map(result => createTicketSelectionEventStatusResultStoreFromLiveData(result)));
        }

        const setDataFromStore = (source: ITicketSelectionEventStatusAsStore) => {
            self.mainScore = source.mainScore,
                self.stateName = source.stateName,
                self.stateTime = source.stateTime,
                self.importantResults = observable(source.importantResults.map((result: ITicketSelectionEventStatusResultAsStore) => TicketSelectionEventStatusResultStore.create(result)));
        }

        return {
            setDataFromLiveApi,
            setDataFromStore
        }
    });

export const createTicketSelectionEventStatusResultStoreFromLiveData = (item: ApiLiveEventsStatusResultItemData) => {
    // same in createTicketSelectionEventStatusResultStoreFromLiveData and createTicketSelectionEventStatusResultStoreFromProto
    const parsedScore = item.Score ? item.Score.split(':') : ['-', '-'];
    let response = TicketSelectionEventStatusResultStore.create(<SnapshotOut<typeof TicketSelectionEventStatusResultStore>>{
        id: item.ID,
        name: item.Name,
        score: item.Score,
        score1: parsedScore[0],
        score2: parsedScore[1] ? parsedScore[1] : '-',
        isGame: (item.Flags & ResultFlag.Game) == ResultFlag.Game,
        isHalf: (item.Flags & ResultFlag.HalfTime) == ResultFlag.HalfTime
    });
    response.tailorScoreValues(item.Flags);
    return response;
}

export const createTicketSelectionEventStatusResultStoreFromProto = (item: IEventResult) => {
    const parsedScore = item.Score ? item.Score.split(':') : ['-', '-'];
    let response = TicketSelectionEventStatusResultStore.create(<SnapshotOut<typeof TicketSelectionEventStatusResultStore>>{
        id: item.ID,
        name: item.Name,
        score: item.Score,
        score1: parsedScore[0],
        score2: parsedScore[1] ? parsedScore[1] : '-',
        isGame: (item.Flags & ResultFlag.Game) == ResultFlag.Game,
        isHalf: (item.Flags & ResultFlag.HalfTime) == ResultFlag.HalfTime
    });
    response.tailorScoreValues(item.Flags);
    return response;
}

export const TicketSelectionStore = types
    .model('ticketSelectionStore', {
        id: types.string,
        rate: types.number,
        number: types.number,
        sportName: types.string,
        fixtureId: types.number,
        fixtureName: types.string,
        fixtureDate: types.Date,
        resultText: types.maybeNull(types.string),
        resultNote: types.string,
        state: types.number, //TicketSelectionEvalState
        isBanker: types.boolean,
        marketName: types.string,
        tipName: types.string,
        symbol: types.string,
        correctSelectionNames: types.array(types.string),
        regionName: types.maybeNull(types.string),
        tournamentName: types.maybeNull(types.string),
        score: types.maybeNull(types.string),
        offerType: types.maybeNull(types.number), //OfferType
        liveEventStatus: types.maybeNull(TicketSelectionEventStatusStore),
    });